import { createApp } from "vue";
import App from "./App.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "./main.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.use(store).use(router).component("SvgIcon", SvgIcon).use(ElementPlus).mount("#app");